module.exports = __webpack_public_path__ + "static/media/aparatologia_slider1.24edd925.webp";